
import { defineComponent, onMounted, watchEffect, computed } from 'vue';
import { useTimer } from 'vue-timer-hook';

export default defineComponent({
  name: 'Clock2',
  props: {
    time: {
      type: Number,
      required: true,
      default: 600,
    },
  },
  setup(props) {
    const time = new Date();
    const totalTime = time.getSeconds() + props.time;
    time.setSeconds(totalTime); // 10 minutes timer
    const timer = useTimer(+time);

    const isZero = computed(() => {
      return (
        +timer.hours.value === 0 &&
        +timer.minutes.value === 0 &&
        +timer.seconds.value === 0
      );
    });

    const getTime = () => {
      return props.time - getTimeInSeconds();
    };

    const getTimeInSeconds = () => {
      console.log('getTimeInSeconds');
      return (
        +timer.seconds.value +
        +timer.minutes.value * 60 +
        +timer.hours.value * 60 * 60
      );
    };

    onMounted(() => {
      // eslint-disable-next-line @typescript-eslint/no-misused-promises, @typescript-eslint/require-await
      watchEffect(async () => {
        if (timer.isExpired.value) {
          console.warn('IsExpired');
        }
      });
    });
    1;
    return {
      getTime,
      getTimeInSeconds,
      timer,
      isZero,
    };
  },
});
